// Display helpers for Дюжина (pure, unit-tested).

export function formatClock(ms) {
  const total = Math.max(0, Math.round((ms || 0) / 1000));
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

export function formatCountdown(ms) {
  if (ms <= 0) return '';
  const hours = Math.floor(ms / 3600000);
  const minutes = Math.floor((ms % 3600000) / 60000);
  const seconds = Math.floor((ms % 60000) / 1000);
  const parts = [];
  if (hours > 0) parts.push(`${hours}ч`);
  if (minutes > 0 || hours > 0) parts.push(`${minutes}м`);
  parts.push(`${seconds}с`);
  return parts.join(' ');
}

export function pointsLabel(points) {
  const mod10 = points % 10;
  const mod100 = points % 100;
  if (mod10 === 1 && mod100 !== 11) return `${points} очко`;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return `${points} очка`;
  return `${points} очков`;
}

function zoneLabel(timeZone) {
  return timeZone === 'Europe/Moscow' ? 'МСК' : timeZone;
}

/** Rules line from GET /api/dozen/schedule: { daily: {hour, minute} | null, timezone, nextPuzzleTime }. */
export function publishLine(schedule) {
  if (!schedule) return 'Каждый день публикуется новая дюжина: 12 слов.';
  const { daily, timezone, nextPuzzleTime } = schedule;
  if (daily) {
    const time = `${String(daily.hour).padStart(2, '0')}:${String(daily.minute).padStart(2, '0')}`;
    return `Каждый день в ${time} (${zoneLabel(timezone)}) публикуется новая дюжина: 12 слов.`;
  }
  if (!nextPuzzleTime) return 'Новая дюжина (12 слов) выходит по расписанию.';
  const next = new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric',
    month: 'long',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: timezone
  }).format(new Date(nextPuzzleTime));
  return `Новая дюжина (12 слов) выходит по расписанию, ближайшая: ${next} (${zoneLabel(timezone)}).`;
}

export function formatPuzzleDate(publishedAt) {
  if (!publishedAt) return '';
  const when = new Date(`${String(publishedAt).replace(' ', 'T')}Z`);
  if (Number.isNaN(when.getTime())) return '';
  return new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric',
    month: 'long',
    timeZone: 'Europe/Moscow'
  }).format(when);
}
